import { useState } from 'react';
import { MdCreateNewFolder } from 'react-icons/md';
import { Button } from '@nbirl/nbi-common-ui-libs';
import { FormikConfig } from 'formik';

import { useErrorToast } from '../../../../shared/hooks';
import { ApiError } from '../../../../shared/models';
import { useCreateNewFolder } from '../queries';
import { FolderNameFormValue } from './folder-name-form';
import { FolderNameModal } from './folder-name-modal.component';

type CreateFolderProps = {
  modalHeading: string;
  className?: string;
  parentId?: string;
  text?: string;
  onSuccess: () => void;
};

export const CreateFolder = ({
  text,
  modalHeading,
  parentId,
  className,
  onSuccess,
}: CreateFolderProps) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const mutation = useCreateNewFolder();
  const { showErrorToast } = useErrorToast();

  const handleModalOpen = () => {
    setModalOpen(true);
  };
  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleSubmit: FormikConfig<FolderNameFormValue>['onSubmit'] = async (
    values,
    formikHelpers
  ) => {
    const { name } = values;

    try {
      await mutation.mutateAsync({ name, parentId });
      handleModalClose();
      onSuccess();
    } catch (error) {
      if (error instanceof ApiError && error.code === '03001') {
        formikHelpers.setFieldError('name', error.message);
      } else {
        showErrorToast('Unable to add new folder. Please try again.');
      }
    }
  };

  return (
    <>
      <Button
        onClick={handleModalOpen}
        variant="ghost"
        disabled={mutation.isLoading}
        className={className}
        leftIcon={<MdCreateNewFolder />}
      >
        {text}
      </Button>

      <FolderNameModal
        modalHeading={modalHeading}
        onSubmit={handleSubmit}
        isOpen={isModalOpen}
        onModalClose={handleModalClose}
        isLoading={mutation.isLoading}
      />
    </>
  );
};
